import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-menu',
  templateUrl: './home-menu.component.html',
  styleUrls: ['./home-menu.component.css']
})
export class HomeMenuComponent implements OnInit {

  menuList:any;
  pageList:any;
  
  constructor() { }

  ngOnInit() {
    this.menuList=localStorage.getItem('menuList');
    this.menuList=JSON.parse(this.menuList);
    for(let i=0; i<this.menuList.length; i++){
      if(this.menuList[i].KHB_MenuName=='Home')
        this.pageList=this.menuList[i].KHB_PagesList;
    }
    
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/home/home-menu/home-menu.component.ts